import { useEffect, useRef, useState } from "react"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { MONO } from "../constants"

export function VoicePlayer({ voice, mime }) {
  const audioRef = useRef(null)
  const blobUrlRef = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [progress, setProgress] = useState(0)
  const [duration, setDuration] = useState(0)
  const [playError, setPlayError] = useState(false)

  useEffect(() => {
    setPlayError(false)
    setPlaying(false)
    setProgress(0)
    setDuration(0)
    try {
      const dataUrl = voice.startsWith("data:") ? voice : `data:${mime || "audio/webm"};base64,${voice}`
      const commaIdx = dataUrl.indexOf(",")
      const header = dataUrl.slice(0, commaIdx)
      const b64 = dataUrl.slice(commaIdx + 1)
      const mimeMatch = header.match(/^data:([^;,]+)/)
      const blobMime = mimeMatch ? mimeMatch[1] : (mime || "audio/webm")
      const bytes = atob(b64)
      const ab = new ArrayBuffer(bytes.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < bytes.length; i++) ia[i] = bytes.charCodeAt(i)
      const blob = new Blob([ab], { type: blobMime })
      const url = URL.createObjectURL(blob)
      if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current)
      blobUrlRef.current = url
      if (audioRef.current) audioRef.current.src = url
    } catch {
      setPlayError(true)
    }
    return () => {
      if (blobUrlRef.current) { URL.revokeObjectURL(blobUrlRef.current); blobUrlRef.current = null }
    }
  }, [voice, mime])

  const toggle = () => {
    const a = audioRef.current
    if (!a || playError) return
    if (playing) { a.pause(); setPlaying(false) }
    else { a.play().catch(() => { setPlaying(false); setPlayError(true) }); setPlaying(true) }
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 140 }}>
      <audio ref={audioRef} onEnded={() => setPlaying(false)}
        onTimeUpdate={(e) => setProgress(e.target.currentTime)}
        onLoadedMetadata={(e) => setDuration(e.target.duration)} style={{ display: "none" }} />
      <IconButton size="small" onClick={toggle} disabled={playError} sx={{ color: playError ? "var(--app-error)" : "var(--app-success)", p: "2px" }}>
        <span style={{ fontSize: 13 }}>{playError ? "✕" : playing ? "⏸" : "▶"}</span>
      </IconButton>
      <Box sx={{ flex: 1, height: 3, backgroundColor: "rgba(var(--app-fg-rgb),0.1)", borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ height: "100%", width: (duration > 0 ? (progress / duration) * 100 : 0) + "%",
          backgroundColor: playError ? "var(--app-error)" : "var(--app-success)", borderRadius: 2, transition: "width 0.2s linear" }} />
      </Box>
      <Typography sx={{ fontFamily: MONO, fontSize: "0.55rem", color: playError ? "var(--app-error)" : "rgba(var(--app-fg-rgb),0.4)", flexShrink: 0 }}>
        {playError ? "err" : duration > 0 ? Math.ceil(duration) + "s" : ""}
      </Typography>
    </Box>
  )
}
